import { Button, Card, Col, Flex, Form, Input, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { notifyError, notifySuccess } from '../../../store/utils';
import CustomerSelect from '../../../lib/CustomerSelect';
import { API } from '../../../api';

const CustomerStaffUpdate = () => {
  const { memberNo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const fetchMember = useCallback(
    async (memberNo: string) => {
      try {
        const { result } = await API.get({ apiVersion: 'api' })(
          `/member/customer/staff/${memberNo}`
        );
        const roles = result?.data?.roles || [];
        form.setFieldsValue({
          customerNo: roles?.[0]?.customer?.no,
          email: result?.data?.email,
          fname: result?.data?.firstName,
          lName: result?.data?.lastName,
          phone1: result?.data?.phone,
        });
      } catch (error: any) {
        notifyError(error.message);
      }
    },
    [form]
  );

  const onFinish = useCallback(
    async (values: any) => {
      try {
        setLoading(true);
        if (memberNo) {
          await API.put({ apiVersion: 'api' })(`/member/customer/staff/update/${memberNo}`, values);
          notifySuccess('Амжилттай хадгаллаа');
        } else {
          await API.post({ apiVersion: 'api' })(`/member/customer/staff/create`, values);
          notifySuccess('Амжилттай хадгаллаа');
          navigate('/settings/customer/staff');
        }
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [memberNo]
  );

  useEffect(() => {
    if (memberNo) {
      fetchMember(memberNo);
    }
  }, [memberNo]);

  return (
    <Card title={`Харилцагч ажилтан ${memberNo ? 'засах' : 'нэмэх'}`}>
      <Row>
        <Col span={12} offset={6}>
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.Item
              name="customerNo"
              label="Харилцагч"
              rules={[{ required: true, message: 'Харилцагч сонгоно уу' }]}
            >
              <CustomerSelect disabled={!!memberNo} allowClear showSearch />
            </Form.Item>
            <Form.Item
              name="email"
              label="Нэвтрэх нэр"
              rules={[{ required: true, message: 'Нэвтрэх нэр оруулна уу' }]}
            >
              <Input disabled={!!memberNo} placeholder="Нэвтрэх нэр" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Нууц үг"
              rules={[{ required: memberNo ? false : true, message: 'Нууц үг оруулна уу' }]}
            >
              <Input placeholder="Нууц үг" />
            </Form.Item>
            <Form.Item
              name="fname"
              label="Нэр"
              rules={[{ required: true, message: 'Нэр оруулна уу' }]}
            >
              <Input placeholder="Нэр" />
            </Form.Item>
            <Form.Item
              name="phone1"
              label="Утас"
              rules={[{ required: true, message: 'Утас оруулна уу' }]}
            >
              <Input placeholder="Утас" />
            </Form.Item>
            <Form.Item>
              <Flex justify="end" gap={24}>
                <Button onClick={() => navigate(-1)} htmlType="button">
                  Буцах
                </Button>
                <Button loading={loading} type="primary" htmlType="submit">
                  Хадгалах
                </Button>
              </Flex>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Card>
  );
};

export default CustomerStaffUpdate;
